import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import { Tour } from 'src/app/model/tour/tour';
import { TourItem } from 'src/app/model/tour/tour-item';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import { PlanningDateService } from 'src/app/services/planning-date-service';
import { ImmoIPPlacerTourListHelper } from './helper/immo-ip-placer-tour-list-helper';

@Component({
  selector: 'immo-ip-placer-tour-list',
  templateUrl: './immo-ip-placer-tour-list.component.html',
  styleUrls: ['./immo-ip-placer-tour-list.component.scss'],
  providers: [PrintAddressPipe, FormatPhoneNumber],
})
export class ImmoIPPlacerTourListComponent implements OnInit {
  @Input()
  tour: Tour;

  loading: boolean = true;

  SUB_PROJECT_TYPES = SUB_PROJECT_TYPES;

  constructor(
    private printAddressPipe: PrintAddressPipe,
    private planningDateService: PlanningDateService,
    private router: Router,
    private formatPhoneNumber: FormatPhoneNumber
  ) {}

  ngOnInit(): void {
    if (CollectionHelper.isPopulated(this.tour.tourItems)) {
      ImmoIPPlacerTourListHelper.processTourItems(
        this.tour.tourItems,
        this.printAddressPipe,
        this.formatPhoneNumber
      );
    }
    this.loading = false;
    this.tour.tourItems.forEach(function (item) {});
  }

  openTourItem(tourItem: TourItem): void {
    if (
      tourItem == null ||
      (tourItem.subProject == null && tourItem.immoTask == null)
    ) {
      return;
    }
    const route = `/ip-installateur/${
      tourItem.subProject != null ? 'opdracht' : 'taak'
    }`;
    const id =
      tourItem.subProject != null
        ? tourItem.subProject.id
        : tourItem.immoTask.id;
    this.router.navigate([
      route,
      DateHelper.formatDate(
        this.planningDateService
          .getSelectedPlanningDateSubscribable()
          .getValue(),
        'yyyyMMdd'
      ),
      id,
    ]);
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
